import { render, staticRenderFns } from "./EditorBlockSortObjects.vue?vue&type=template&id=0bda4558&scoped=true"
import script from "./EditorBlockSortObjects.vue?vue&type=script&lang=js"
export * from "./EditorBlockSortObjects.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockSortObjects.vue?vue&type=style&index=0&id=0bda4558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda4558",
  null
  
)

export default component.exports